import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/organizations'

export default class NotchControllerServiceOrganization {
    static async add(detailId, data) {
        return await axios.post(`${detailControllerRestUrl}/notches/rect?detailId=${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(notchId) {
        return await axios.delete(`${detailControllerRestUrl}/notches/${notchId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async put(notchId, data) {
        return await axios.put(`${detailControllerRestUrl}/notches/${notchId}/update-params`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addRound(detailId, data) {
        return await axios.post(`${detailControllerRestUrl}/round-notches?detailId=${detailId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteRound(notchId) {
        return await axios.delete(`${detailControllerRestUrl}/round-notches/${notchId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async putRound(notchId, data) {
        return await axios.put(`${detailControllerRestUrl}/round-notches/${notchId}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
